export default __webpack_public_path__ + "static/media/contacts.d0cddf29.svg";